import { useState } from "react";
import { Play } from "lucide-react";
import { fileUrl } from "@/lib/api";
import Lightbox from "@/components/Lightbox";

function Thumb({ item, onOpen }) {
  const src = fileUrl(item.thumb_url);
  return (
    <button onClick={onOpen} className="relative aspect-square rounded-xl overflow-hidden bg-[#F3ECE1] group" data-testid="timeline-item">
      {src ? <img src={src} alt="" loading="lazy" decoding="async" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        : <span className="w-full h-full grid place-items-center text-xs text-[#968E87]">Video</span>}
      {item.type === "video" && <span className="absolute inset-0 grid place-items-center"><span className="w-9 h-9 rounded-full bg-black/45 grid place-items-center text-white"><Play size={15} /></span></span>}
      <span className="absolute bottom-1 left-1 text-[10px] px-1.5 py-0.5 rounded bg-black/45 text-white">{(item.timeline_at || "").slice(11, 16)}</span>
    </button>
  );
}

export default function Timeline({ sections, showEmpty = false, title }) {
  const [open, setOpen] = useState(null);
  const shown = sections.filter((s) => showEmpty || s.items.length);
  const flat = shown.flatMap((s) => s.items);
  const offsets = [];
  shown.reduce((acc, s) => { offsets.push(acc); return acc + s.items.length; }, 0);
  if (!shown.length) return <p className="text-center text-[#6C6560] py-16" data-testid="timeline-empty">Časovnica se bo napolnila, ko bodo gostje naložili spomine.</p>;

  return (
    <section data-testid="timeline">
      {title && <h2 className="font-display text-3xl sm:text-4xl font-light text-center mb-6">{title}</h2>}
      <nav className="flex gap-2 overflow-x-auto no-scrollbar pb-4 -mx-4 px-4 sticky top-0 z-20 bg-[#FAF7F2]/90 backdrop-blur pt-2">
        {shown.map((s) => (
          <button key={s.id} onClick={() => document.getElementById(`tl-${s.id}`)?.scrollIntoView({ behavior: "smooth", block: "start" })} className="px-3 py-1.5 rounded-full text-xs border border-[#DFD5C5] bg-[#FFFDF9] whitespace-nowrap" data-testid={`timeline-nav-${s.id}`}>{s.time ? `${s.time} · ` : ""}{s.title}</button>
        ))}
      </nav>
      <ol className="relative border-l border-[#D9C7A8] ml-3 sm:ml-6 space-y-10 mt-4">
        {shown.map((s, si) => (
          <li key={s.id} id={`tl-${s.id}`} className="pl-6 sm:pl-10 scroll-mt-20" data-testid="timeline-section">
            <span className="absolute -left-[7px] w-3.5 h-3.5 rounded-full bg-[#C5A880] ring-4 ring-[#FAF7F2]" />
            <div className="flex items-baseline gap-3 flex-wrap">
              {s.time && <span className="font-display text-3xl text-[#B39264]">{s.time}</span>}
              <h3 className="font-display text-2xl">{s.title}</h3>
              <span className="text-xs text-[#968E87]">{s.items.length} {s.items.length === 1 ? "spomin" : "spominov"}</span>
            </div>
            {s.items.length ? (
              <div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-2 mt-4">
                {s.items.map((m, i) => <Thumb key={m.id} item={m} onOpen={() => setOpen(offsets[si] + i)} />)}
              </div>
            ) : <p className="text-sm text-[#968E87] mt-2">Še ni spominov iz tega dela dneva.</p>}
          </li>
        ))}
      </ol>
      <Lightbox items={flat} index={open} onClose={() => setOpen(null)} onIndex={setOpen} />
    </section>
  );
}
